import { _getSessionStore } from "@/utils/storage";
let localUrl = _getSessionStore("auth_rule", "JSONStr");
export const tableInShow = url => {
  for (let i = 0; i < localUrl.length; i++) {
    // if( typeof localUrl[i] )
    if (localUrl[i].url == url && typeof localUrl[i] == "object") return true;
    if (localUrl[i] == url) return true;
  }
  return false;
};
